
export default class ConversationPhaseReasoningEvent {
    constructor(type, reasoning) {
        this._type = type;

        this._reasoning = reasoning;
    }

    get type() {
        return this._type;
    }

    get reasoning() {
        return this._reasoning;
    }
}

ConversationPhaseReasoningEvent.PERFORM = "ConversationPhaseReasoningEvent.PERFORM";